const mEditionMapEnrollmentsFamilyMembersModalDelete = {
  mEditionMapEnrollmentsFamilyMembersModalDelete: {
    alerts: {
      deleteIntegrante: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El integrante fue eliminado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará el integrante',
      options: 'del equipo',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Integrante'
  }
}

export default mEditionMapEnrollmentsFamilyMembersModalDelete
